import { render, staticRenderFns } from "./PluginCom.vue?vue&type=template&id=847fcb8a"
import script from "./PluginCom.vue?vue&type=script&lang=js"
export * from "./PluginCom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports